<div class="popup-container">
    <div class="popup-header">
        Enter the URL
    </div>
    <input type="text" [(ngModel)]="inputValue" placeholder="Enter value here" />
    <div class="popup-footer">
        <button class="btn btn-outline" mat-button (click)="close()">Cancel</button>
        <button class="btn btn-primary" mat-button (click)="submitValue()">Submit</button>
    </div>
</div>